/**
 * API compatível com Sonner — redirecionada via alias webpack para modais Office.
 */
import { dismissOfficeNotify, emitOfficeNotify } from './officeNotifyBus';
import { formatNotifyMessage } from './formatNotifyMessage';

let seq = 0;

function nextId(fallback) {
  seq += 1;
  return fallback != null ? String(fallback) : `office-fb-${seq}`;
}

function emit(type, message, options = {}) {
  const formatted = formatNotifyMessage(message);
  const isRate =
    /rate-overlimit|pediu pausa|limite de envios|muitos pedidos/i.test(String(formatted || '')) ||
    /rate-overlimit|pediu pausa|limite de envios|muitos pedidos/i.test(String(message || ''));
  // Um único modal de rate-limit — evita fila infinita de «Entendi».
  const id = nextId(options.id || (type === 'error' && isRate ? 'wa-rate-limit' : undefined));
  if (type !== 'loading' && (options.id || isRate)) {
    dismissOfficeNotify(id);
  }
  emitOfficeNotify({
    type: isRate && type === 'error' ? 'warning' : type,
    id,
    message: formatted,
    title: options.title || (isRate ? 'WhatsApp pediu uma pausa' : undefined),
    duration: options.duration,
  });
  return id;
}

export const toast = {
  success(message, options) {
    return emit('success', message, options);
  },
  error(message, options) {
    return emit('error', message, options);
  },
  info(message, options) {
    return emit('info', message, options);
  },
  warning(message, options) {
    return emit('warning', message, options);
  },
  loading(message, options) {
    return emit('loading', message, { ...options, id: options?.id || nextId('loading') });
  },
  message(message, options) {
    return emit('info', message, options);
  },
  dismiss(id) {
    dismissOfficeNotify(id);
  },
  async promise(promise, messages) {
    const id = emit('loading', messages?.loading || 'Processando…', { id: 'toast-promise' });
    try {
      const result = await promise;
      dismissOfficeNotify(id);
      const okMsg =
        typeof messages?.success === 'function' ? messages.success(result) : messages?.success;
      emit('success', okMsg || 'Concluído');
      return result;
    } catch (err) {
      dismissOfficeNotify(id);
      const errMsg = typeof messages?.error === 'function' ? messages.error(err) : messages?.error;
      emit('error', errMsg || err?.message || 'Falha na operação');
      throw err;
    }
  },
};

/** Sonner exporta Toaster — no-op (modais via OfficeFeedbackProvider). */
export function Toaster() {
  return null;
}

export { toast as default };
